// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource';  
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import { existsMenuRight } from './api/api';
import Vuex from 'vuex'

Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store({
    state: {        
      menu:[]
    }
})

router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
    next();
    return;
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
    
  } else {

    if (to.path=='/')
    {
      next({ path: '/home' });
      return;
    }

    if (to.path=='/home')
    {
      next();
      return;
    }
     if (to.path=='/error')
    {
      next();
      return;
    }
     
     if (sessionStorage.getItem('right')=="1")
     {
       next();
       return;
     }
      
            Vue.http.jsonp(existsMenuRight, {params: {CurrentUserID:sessionStorage.getItem('userID'),Session:sessionStorage.getItem('session'),Path:to.path}})
            .then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {                         
                               next();                                                
                         }
                         else{   
                             
                               if (res.data.result_code==911)
                              {
                                  next({ path: '/login' });
                                  return;
                              }

                              if (res.data.result_code==910)
                              {                               
                                next({ path: '/error' })
                                return;
                              }                             
                         }                      

                   },
                   function(res)
                   {                        
                        next({ path: '/error' })
                   }
           )

    
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js